import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  InformationBoxComponent,
  PracticeMohSettingsComponent,
} from '@principle-theorem/ng-principle-shared';
import { Practice } from '@principle-theorem/principle-core';
import {
  IPractice,
  REQUIRED_MOH_PRACTICE_SETTING_LABEL_MAP,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';

@Component({
  selector: 'pr-moh-practice-settings-dialog',
  imports: [
    PracticeMohSettingsComponent,
    MatToolbarModule,
    InformationBoxComponent,
  ],
  templateUrl: './moh-practice-settings-dialog.component.html',
  styleUrl: './moh-practice-settings-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MohPracticeSettingsDialogComponent {
  practice = inject<WithRef<IPractice>>(MAT_DIALOG_DATA);
  dialogRef = inject(
    MatDialogRef<MohPracticeSettingsDialogComponent, WithRef<IPractice>>
  );
  missingFields = Practice.missingMohSettings(this.practice).map(
    (setting) => REQUIRED_MOH_PRACTICE_SETTING_LABEL_MAP[setting]
  );
}
